<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    {{ task }} Stream {{title}}
  </div>
  <button mat-icon-button class="close-btn" (click)="closeModal()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form id="MaterialStreamForm" #streamForm="ngForm" class="form-grid">
    <mat-accordion>
      <!-- Stream Details Panel -->
      <mat-expansion-panel [expanded]="true" [expanded]="detailsExpanded()">
        <mat-expansion-panel-header style="height: 53px;background-color: #ebe7e7;">
          <mat-panel-title>
            Stream Details
          </mat-panel-title>
        </mat-expansion-panel-header>
        <!-- Row 1: Stream (Mandatory) - Full Width -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Stream</mat-label>
            <input matInput type="text" #streamInput="ngModel" name="stream" placeholder="Enter Stream"
              [ngModel]="streamData().stream" (ngModelChange)="onInputChange('stream', $event)"
              [disabled]="controlPermissions.stream" maxlength="240" required>
            @if (streamInput.invalid && (streamInput.dirty || streamInput.touched)) {
              <mat-error>
                @if (streamInput.hasError('required')) {
                Stream is required.
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <!-- Row 2: Stream Group & Stream Matrix -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Stream Group</mat-label>
            <mat-select name="streamFood" [ngModel]="streamData().streamFood"
              (ngModelChange)="onInputChange('streamFood', +$event)" [disabled]="controlPermissions.streamFood">
              <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                <input #sgSearchInput matInput placeholder="Search Stream Group..."
                  (input)="filterStreamGroups($event)" class="mat-select-search-input"
                  aria-label="Search Stream Group" (keydown)="$event.stopPropagation();" />
                <mat-icon class="mat-select-search-icon">search</mat-icon>
              </div>
              <mat-option [value]="null">- Select Stream Group -</mat-option>
              @for (item of filteredFoodGroups(); track item.id) {
                <mat-option [value]="item.id">{{ item.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Stream Matrix</mat-label>
            <mat-select name="streamMatrix" [ngModel]="streamData().streamMatrix"
              (ngModelChange)="onInputChange('streamMatrix', +$event)" [disabled]="controlPermissions.streamMatrix">
              <mat-option [value]="null">- Select Stream Matrix -</mat-option>
              @for (item of foodMatrices(); track item.id) {
                <mat-option [value]="item.id">{{ item.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <!-- Row 3: Stream Strength & Projected Volume -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Stream Strength</mat-label>
            <mat-select name="strengthID" [ngModel]="streamData().strengthID"
              (ngModelChange)="onInputChange('strengthID', +$event)" [disabled]="controlPermissions.strengthID">
              <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                <input #stSearchInput matInput placeholder="Search Stream Strength..."
                  (input)="filterStreamStrength($event)" class="mat-select-search-input"
                  aria-label="Search Stream Strength" (keydown)="$event.stopPropagation();" />
                <mat-icon class="mat-select-search-icon">search</mat-icon>
              </div>
              <mat-option [value]="null">- Select Stream Strength -</mat-option>
              @for (item of filteredStreamStrengths(); track item.id) {
                <mat-option [value]="item.id">{{ item.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Projected Volume</mat-label>
            <input matInput type="text" name="projectedVolume" placeholder="Enter Projected Volume"
              [ngModel]="streamData().projectedVolume" (ngModelChange)="onInputChange('projectedVolume', +$event)"
              [disabled]="controlPermissions.projectedVolume"
              (input)="roundOff($event, 999999, 0, 'projectedVolume')">
          </mat-form-field>
        </div>

        <!-- Row 4: Oracle Site Number & Sales Representative -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Oracle Site Number</mat-label>
            <input matInput type="text" name="siteNumber" placeholder="Enter Oracle Site Number"
              [ngModel]="streamData().siteNumber" [disabled]="controlPermissions.siteNumber"
              (input)="roundOff($event, 99999999, 0, 'siteNumber')">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>BDR</mat-label>
            <mat-select name="bdrId" [ngModel]="streamData().bdr" (ngModelChange)="onInputChange('bdr', +$event)"
              [disabled]="controlPermissions.bdr">
              <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                <input #marketSearchInput matInput placeholder="Search BDRs..." (input)="filterBdrEmployees($event)"
                  class="mat-select-search-input" aria-label="Search BDRs" (keydown)="$event.stopPropagation();" />
                <mat-icon class="mat-select-search-icon">search</mat-icon>
              </div>
              <mat-option [value]="null">- Select BDR -</mat-option>
              @for (item of filteredbdrEmployees(); track item.id) {
              <mat-option [value]="item.id">{{ item.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <!-- Row 5: Hauler & Disposal Method -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Hauler</mat-label>
            <mat-select name="haulerId" [ngModel]="streamData().haulerId" #haulInput="ngModel" required
              (ngModelChange)="onInputChange('haulerId', $event == null ? null : +$event)" [disabled]="controlPermissions.haulerId">
              <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                <input #marketSearchInput matInput placeholder="Search Haulers..." (input)="filterHaulers($event)"
                  class="mat-select-search-input" aria-label="Search Haulers" (keydown)="$event.stopPropagation();" />
                <mat-icon class="mat-select-search-icon">search</mat-icon>
              </div>
              <mat-option [value]="null">- Select Hauler -</mat-option>
              @for (item of filteredHaulers(); track item.id) {
                <mat-option [value]="item.id">{{ item.name }}</mat-option>
              }
            </mat-select>
            @if (haulInput.invalid && (haulInput.dirty || haulInput.touched)) {
              <mat-error>
                @if (haulInput.hasError('required')) {
                Hauler is required.
                }
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Disposal Method</mat-label>
            <mat-select name="disposalMethodId" [ngModel]="streamData().disposalMethodId"
              (ngModelChange)="onInputChange('disposalMethodId', +$event)"
              [disabled]="controlPermissions.disposalMethodId">
              <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                <input #marketSearchInput matInput placeholder="Search Disposal Methods..."
                  (input)="filterDisposalMethods($event)" class="mat-select-search-input"
                  aria-label="Search Disposal Methods" (keydown)="$event.stopPropagation();" />
                <mat-icon class="mat-select-search-icon">search</mat-icon>
              </div>
              <mat-option [value]="null">- Select Disposal Method -</mat-option>
              @for (item of filteredDisposalMethods(); track item.id) {
                <mat-option [value]="item.id">{{ item.disposalMethod }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <!-- Row 6: Opportunity Id -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline" class="form-field-item small flex-100">
            <mat-label>Market</mat-label>
            <mat-select [ngModel]="streamData().marketID" data-testid="marketID" name="marketID"
              (ngModelChange)="onInputChange('marketID', +$event)" [disabled]="controlPermissions.marketID">
              <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                <input #marketSearchInput matInput placeholder="Search Market..." (input)="filterMarkets($event)"
                  class="mat-select-search-input" aria-label="Search Market" (keydown)="$event.stopPropagation();" />
                <mat-icon class="mat-select-search-icon">search</mat-icon>
              </div>
              @for (market of filteredStreamRegions(); track market.id) {
                <mat-option [value]="market.id">{{ market.regionName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Opportunity Id</mat-label>
            <input matInput type="text" name="opportunityID" placeholder="Enter opportunity"
              [ngModel]="streamData().opportunityID" (ngModelChange)="onInputChange('opportunityID', $event)"
              [disabled]="controlPermissions.opportunityID" maxlength="50">
          </mat-form-field>
        </div>
        @if (data.isWalmart) {
          <div class="form-grid-row">
            <mat-form-field appearance="outline">
              <mat-label>No. of Bins</mat-label>
              <input matInput type="text" name="noOfBins" inputmode="numeric" maxlength="3"
                placeholder="Enter number of bins" [ngModel]="streamData().noOfBins"
                [disabled]="controlPermissions.noOfBins"
                (input)="roundOff($event, 999, 0, 'noOfBins')">
            </mat-form-field>
          </div>
        }

        <!-- Row 7 : Status & Is Tote -->
        <div class="form-grid-row">         
          <mat-slide-toggle name="status" [ngModel]="streamData().status"
            (ngModelChange)="onInputChange('status', $event)" [disabled]="controlPermissions.status" color="primary"
            >
            <span class="font-medium text-gray-700 w-28 inline-block">Status</span>
          </mat-slide-toggle>
          <mat-slide-toggle name="Tote" [ngModel]="streamData().isTote"
            (ngModelChange)="onInputChange('isTote', $event)" [disabled]="controlPermissions.isTote" color="primary"
            >
            <span>Is Tote</span>
          </mat-slide-toggle>
        </div>
        <!-- Row 8: Commission Eligible & Rebate Eligible -->
        <div class="form-grid-row">        
          <mat-slide-toggle name="commissionEligible" [ngModel]="streamData().commissionEligible"
            (ngModelChange)="onInputChange('commissionEligible', $event)" [disabled]="controlPermissions.commissionEligible"
            color="primary">
            <span >Commission Eligible</span>
          </mat-slide-toggle>
          <mat-slide-toggle name="rebateEligible" [ngModel]="streamData().rebateEligible"
            (ngModelChange)="onInputChange('rebateEligible', $event)"
            [disabled]="controlPermissions.rebateEligible" color="primary">
            <span >Rebate Eligible</span>
          </mat-slide-toggle>
        </div>
        <!-- Row 9: COD & COD Email -->
        <div class="form-grid-row">
          <mat-slide-toggle name="CODRequired" [ngModel]="streamData().codRequired"
            (ngModelChange)="onCODChange($event)" [disabled]="controlPermissions.codRequired" color="primary" >
            <span >COD Required</span>
          </mat-slide-toggle>
          <mat-form-field appearance="outline">
            <mat-label>COD Email</mat-label>
            <input matInput type="text" appMultiEmail name="CODEmail" #codEmailInput="ngModel"
              placeholder="Enter COD Email" [ngModel]="streamData().codEmail"
              (ngModelChange)="onInputChange('codEmail', $event)"
              [disabled]="controlPermissions.codRequired == true ? true : !streamData().codRequired"
              maxlength="2000">
            <mat-hint>Multiple emails separated by a semicolon (;)</mat-hint>
            @if (codEmailInput.invalid && (codEmailInput.dirty || codEmailInput.touched)) {
            <mat-error>
              @if (codEmailInput.hasError('required')) {
                COD Email is required when COD Required is enabled.
              }
              @if (codEmailInput.hasError('email')) {
                Must be a valid email format.
              }
              @if (codEmailInput.hasError('multiEmail')) {
                One or more email addresses are invalid.
              }
            </mat-error>
            }
          </mat-form-field>
        </div>
        <!-- Row 9: Expense & outbount Email -->
        <div class="form-grid-row">
          <mat-slide-toggle name="isExpense" [ngModel]="streamData().isExpense"
            (ngModelChange)="onInputChange('isExpense', $event)" [disabled]="controlPermissions.isExpense" color="primary">
            <span>Is Expense</span>
          </mat-slide-toggle>
          <mat-slide-toggle name="isOutbound" [ngModel]="streamData().isOutBound"
            (ngModelChange)="onInputChange('isOutBound', $event)" [disabled]="controlPermissions.isOutBound" color="primary">
            <span>Is Outbound</span>
          </mat-slide-toggle>
        </div>
        <!-- Row 10: customer reference -->
        <div class="form-grid-row">
          <mat-slide-toggle name="isCustomerReferenceRequired" [ngModel]="streamData().isCustomerReferenceRequired"
            (ngModelChange)="onInputChange('isCustomerReferenceRequired', $event)"
            [disabled]="controlPermissions.isCustomerReferenceRequired" color="primary">
            <span>Customer Reference# Required</span>
          </mat-slide-toggle>
        </div>
      </mat-expansion-panel>
      <!-- Group 2: Pickup Location (New Content) -->
      <mat-expansion-panel  style="margin-bottom:15px; margin-top: 15px;"
        [expanded]="pickupExpanded()">
        <mat-expansion-panel-header class="bg-gray-100 rounded-t-lg expansionHeader"
          style="height: 53px;background-color: #ebe7e7;">
          <mat-panel-title>
            Logistics Details
          </mat-panel-title>
        </mat-expansion-panel-header>
       
        <!-- Row 1 --> 
        <div class="form-grid-row">        
          <mat-form-field appearance="outline">
            <mat-label>Location Name</mat-label>
            <input matInput type="text" #locationNameInput #locName="ngModel" placeholder="Enter Location Name"
              [disabled]="controlPermissions.pickupLocationName"
              [ngModel]="streamData().pickupLocationName"
              (ngModelChange)="onInputChange('pickupLocationName', $event)"
              name="locationName" required maxlength="100">
            @if (!pickupLocationName() && (locName.invalid && (locName.dirty || locName.touched))) {
            <mat-error>Location Name is required</mat-error>
            }
          </mat-form-field>

          <mat-slide-toggle (change)="onAddressCheck($event)"
            [disabled]="controlPermissions.sameAsCustomerAddress"
            [ngModel]="streamData().sameAsCustomerAddress"
            (ngModelChange)="onInputChange('sameAsCustomerAddress', $event)" name="sameAsCustomerAddressToggle"
            color="primary">
            Same as CustomerAddress?
          </mat-slide-toggle>
        </div>
        <!-- Row 2 --> 
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Address Line 1</mat-label>
            <input matInput type="text" #addr1Input #addr1="ngModel" placeholder="Enter Address Line 1"
              [ngModel]="streamData().addressLine1" (ngModelChange)="onInputChange('addressLine1', $event)"
              name="addressLine1" maxlength="50"
              [disabled]="sameAsCustomerAddress() === true ? true : controlPermissions.addressLine1"
              [required]="!streamData().sameAsCustomerAddress">
            @if (!sameAsCustomerAddress() && (addr1.invalid && (addr1.dirty || addr1.touched))) {
              <mat-error>Address Line 1 is required</mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Address Line 2</mat-label>
            <input matInput type="text" #addr2Input placeholder="Enter Address Line 2" maxlength="50"
              [ngModel]="streamData().addressLine2"
              (ngModelChange)="onInputChange('addressLine2', $event)"
              name="addressLine2" [disabled]="sameAsCustomerAddress() === true ? true : controlPermissions.addressLine2">
          </mat-form-field>
        </div>
        <!-- Row 3 --> 
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>State</mat-label>
            <mat-select name="state" placeholder="Select State" (selectionChange)="onStateChanged($event.value)"
              [disabled]="sameAsCustomerAddress() === true ? true : controlPermissions.stateId"
              [ngModel]="streamData().stateId" #stateCtrl="ngModel"
              (ngModelChange)="onInputChange('stateId', +$event)" [required]="!sameAsCustomerAddress()">
              <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                <input #stateSearchInput matInput placeholder="Search State..." (input)="filterState($event)"
                  class="mat-select-search-input" aria-label="Search State" (keydown)="$event.stopPropagation();" />
                <mat-icon class="mat-select-search-icon">search</mat-icon>
              </div>
              <mat-option [value]="null">Select State</mat-option>
              @for (state of filteredStates(); track state.id) {
                <mat-option [value]="state.id">{{ state.state }}</mat-option>
              }
            </mat-select>
            @if (!sameAsCustomerAddress() && (stateCtrl.invalid && (stateCtrl.dirty || stateCtrl.touched))) {
              <mat-error>State is required</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>City</mat-label>
            <mat-select [ngModel]="streamData().city" #cityCtrl="ngModel"
              (ngModelChange)="onInputChange('city', $event)" name="city" placeholder="Select City"
              [disabled]="sameAsCustomerAddress() === true ? true : controlPermissions.city"
              [required]="!sameAsCustomerAddress()">
              <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                <input #citySearchInput matInput placeholder="Search City..." (input)="filterCity($event)"
                  class="mat-select-search-input" aria-label="Search City" (keydown)="$event.stopPropagation();" />
                <mat-icon class="mat-select-search-icon">search</mat-icon>
              </div>
              <mat-option [value]="null">Select City</mat-option>
              @for (city of filteredCities(); track city.id) {
                <mat-option [value]="city.city">{{ city.city }}</mat-option>
              }
            </mat-select>
            @if (!sameAsCustomerAddress()  && (!streamData().city) && ((cityCtrl.dirty || cityCtrl.touched))) {
              <mat-error>City is required</mat-error>
            }
          </mat-form-field>
        </div>
        <!-- Row 4 -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Zip Code</mat-label>
            <input matInput type="text" #zipInput #zipCtrl="ngModel" placeholder="Enter Zip Code"
              [ngModel]="streamData().zipCode" (ngModelChange)="onInputChange('zipCode', $event)" name="zipCode"
              [disabled]="sameAsCustomerAddress() === true ? true : controlPermissions.zipCode"
              [required]="!sameAsCustomerAddress()" maxlength="10">
            @if (!sameAsCustomerAddress() && (zipCtrl.invalid && (zipCtrl.dirty || zipCtrl.touched))) {
              <mat-error>Zip Code is required</mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Municipality</mat-label>
            <input matInput type="text" #muniInput placeholder="Enter Municipality"
              [ngModel]="streamData().municipality" (ngModelChange)="onInputChange('municipality', $event)"
              name="municipality" [disabled]="sameAsCustomerAddress() === true ? true : controlPermissions.municipality"
              maxlength="50">
          </mat-form-field>
        </div>
        <!-- Row 5 -->
        <div class="form-grid-row">
          <mat-form-field appearance="outline">
            <mat-label>Selfhaul Email</mat-label>
            <input matInput type="text" #shEmaiCtrl="ngModel" placeholder="Enter self haul email"
              [ngModel]="streamData().selfHaulEmail" (ngModelChange)="onInputChange('selfHaulEmail', $event)"
              name="selfHaulEmail" email [disabled]="controlPermissions.selfHaulEmail" pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$">
            @if ((shEmaiCtrl.invalid && (shEmaiCtrl.dirty) && shEmaiCtrl.errors?.['email'])) {
              <mat-error>
                @if (shEmaiCtrl.hasError('email')) {
                  Must be a valid email format.
                }
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Selfhaul Phone</mat-label>
            <input matInput type="text" #muniInput placeholder="Enter Selfhaul Phone"
              [ngModel]="streamData().selfHaulPhone" (keydown)="phoneKeydown($event)" maxlength="14"
              (input)="formatPhoneNumber($event, 'selfHaulPhone')"
              name="selfHaulPhone" [disabled]="controlPermissions.selfHaulPhone"
              placeholder="(999) 000-0000" pattern="^\(\d{3}\) \d{3}-\d{4}$">
          </mat-form-field>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button (click)="closeModal()" type="button" mat-raised-button color="primary">Cancel</button>
  @if(canSave){
    <button type="button" (click)="saveStreamData()" mat-raised-button color="primary">Save</button>
  }
</mat-dialog-actions>